export enum FakturaEndpointErrorEndpoints {
    ESR = 'ESR',
    INVOICE = 'INVOICE',
    ACCOUNT = 'ACCOUNT',
    PAYMENT = 'PAYMENT',
    LAYOUT = 'LAYOUT',
    CLIENT = 'CLIENT',
}
